import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { DatabaseSimpleView } from 'domains/Database/components'

const DatabaseList = (props) => {
  const { databases, isListWithCreate, listView, emptyProps, actions } = props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {databases?.length > 0 ? (
        databases?.map((database, index) => (
          <Col
            mb={4}
            key={database?._id || index}
            cw={listView ? 12 : [12, 6, 4]}>
            <DatabaseSimpleView
              actions={actions}
              index={index}
              isSelected={database?._id === selectedItem}
              onSelect={setSelectedItem}
              database={database}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No databases have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

DatabaseList.propTypes = {
  databases: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default DatabaseList
